/* The two lines a queue item draws about itself on the Pulpit's „Zadania" rows: two lines of
 * sentence reserved, a third allowed (see the note above `.line`). */

.lines {
  --lines-name-size: var(--fs-button-sm);
  --lines-gap: var(--space-1px);
  --lines-reserve: 2;
  --lines-clamp: 3;

  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.name {
  overflow: hidden;
  font-size: var(--lines-name-size);
  font-weight: var(--fw-extrabold);
  color: var(--text);
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: var(--ls-heading);
}

/* The sentence WRAPS. Two lines are reserved, a third is allowed, and nothing is cut before then.
 *
 * It used to be one `nowrap` line with an ellipsis, transcribed from the mock. Measured at 1512 against
 * the real backend the two do not agree: the mock's sentences are 22–37 characters and shrink-wrap
 * inside a 481px card, while mobile's own sentence for a lapsed client ("Klient nie trenował od
 * dłuższego czasu — warto się odezwać.", 59 characters) needs 327px in a box 159px wide — a row is a
 * 32px tile, this text and a 174px control group — so the trainer read half a sentence and a tooltip.
 *
 * Two lines are the RESERVE, so a one-line row and a two-line row are the same height and the list
 * stays a list; the clamp is at three, so the longest sentence the bundle can produce at this width
 * arrives whole instead of cut, and a pathological one is still bounded. `title` carries the full
 * string either way. The skeleton reserves the same two lines (`shared/AGENTS.md` — a box knows its
 * size before its data arrives); a third line is the one row that grows, by 15px, on arrival. */
.line {
  display: -webkit-box;
  min-height: calc(var(--lines-reserve) * var(--fs-micro) * var(--lh-normal));
  margin-block-start: var(--lines-gap);
  overflow: hidden;
  font-size: var(--fs-micro);
  line-height: var(--lh-normal);
  color: var(--text-2);
  text-wrap: pretty;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--lines-clamp);
}

/* ── The reserve ─────────────────────────────────────────────────────────────────────────────
 * The bars `ItemLinesReserve` draws, sized off the same custom properties the real lines read. They were three classes in `TasksCard.module.css` and three in
 * `FeedbackCard.module.css`, reached by importing this file across a slice boundary; the widths are
 * a fact about THIS row's shape, so they live beside it. */

.barName {
  width: 118px;
  height: var(--lines-name-size);
}

.barLine {
  width: 164px;
  height: var(--fs-micro);
  margin-block-start: var(--space-6px);
}

/* The second line of a task row's sentence. */
.barLineB {
  width: 108px;
  height: var(--fs-micro);
  margin-block-start: var(--space-2);
}
